import * as types from './mutations-types';
import { get } from 'lodash-es';
import { ping } from '@phoenix/components/Ping';
import { clientApi } from '@phoenix/clientApi';
import { CURRENT_USER_IS_LOGGED, emitter } from '@phoenix/event-bus';

const initialState = {
  isLogged: null,
  customerInfo: null,
  customerInfoIsLoading: false,
  customerInfoFormData: {},
  onSubmitToken: () => {},
};

const actions = {
  async loadCustomerInfo({ commit, state, dispatch }, forceReload = false) {
    if (forceReload) {
      ping.setShouldRefreshPing();
      dispatch('setCustomerInfo', null);
    }

    if (state.customerInfo === null && !state.customerInfoIsLoading) {
      commit(types.CURRENT_USER_INFO_SET_LOADING, true);
      try {
        const { data } = await ping.getData();

        commit(types.CURRENT_USER_SET_IS_LOGGED_SUCCESS, data.isLogged);
        dispatch('form/setCsrfToken', data.token, { root: true });
        dispatch('wishlist/refreshWishlistFromCookie', null, { root: true });
        dispatch('setCustomerInfo', data.customerInfo);
      } catch (error) {
        window.Phoenix.sentry.captureException(error);
      }

      commit(types.CURRENT_USER_INFO_SET_LOADING, false);
    }
  },

  async updateCustomerInfo({ dispatch }, customer) {
    const response = await clientApi.post(window.route('api.customer.info.update'), customer);

    if (!get(response, ['data', 'status'], false)) {
      throw 'Error.validatingToken';
    }
    dispatch('setCustomerInfo', customer);
  },

  async createCustomerWithToken({}, { data, redirectUrl = '' }) {
    try {
      const response = await clientApi.post(window.route('api.customer.registration'), data);

      if (response.data.message && response.data.message.length > 0) {
        window.Phoenix.notification.create(response.data.message, 'success');
      }

      // If we have a redirection url, it means that we are on the account registration page
      // otherwise, it means that we are on the checkout and we need to reload the page, the same way as for the login
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        location.reload();
      }
    } catch (error) {
      throw 'Error.validatingToken';
    }
  },

  setCustomerInfo({ commit }, customer) {
    commit(types.CURRENT_USER_INFO_SUCCESS, customer);
  },

  async updatePassword({}, data) {
    const response = await clientApi.post(window.route('api.customer.password.update'), data);

    if (!get(response, ['data', 'status'], false)) {
      throw this.$t('MyAccount.errorWhileUpdatingPassword');
    }
  },

  setCustomerInfoFormData({ commit }, data) {
    commit(types.CURRENT_USER_INFO_SET_FORM_DATA, data);
  },

  setOnSubmitToken({ commit }, callback) {
    commit(types.CURRENT_USER_SET_ON_SUBMIT_TOKEN_CALLBACK, callback);
  },

  async logout() {
    await clientApi.post(window.route('api.customer.logout'));
    window.location.href = window.route('homepage');
  },
};

const mutations = {
  [types.CURRENT_USER_SET_IS_LOGGED_SUCCESS](state, isLogged) {
    state.isLogged = isLogged;

    if (isLogged) {
      emitter.emit(CURRENT_USER_IS_LOGGED);
    }
  },

  [types.CURRENT_USER_INFO_SET_LOADING](state, isLoading) {
    state.customerInfoIsLoading = isLoading;
  },

  [types.CURRENT_USER_INFO_SUCCESS](state, data) {
    state.customerInfo = data;
  },

  [types.CURRENT_USER_INFO_SET_FORM_DATA](state, data) {
    state.customerInfoFormData = data;
  },

  [types.CURRENT_USER_SET_ON_SUBMIT_TOKEN_CALLBACK](state, callback) {
    state.onSubmitToken = callback;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
